module.exports = __webpack_public_path__ + "img/ehealthcare_solutions_plugin.5c595d04.png";